<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <h2 class="text-primary" style="margin-bottom: 0px;">
          <i class="fa fa-list" /> Categorias
        </h2>

        <small class="text-muted"
          >Controle e suas categorias de produtos.</small
        >
      </div>

      <div class="col-md-6 text-right">
        <button
          class="btn btn-success"
          style="margin-left:5px"
          @click="openCategoryForm()"
        >
          <i class="fas fa-plus" /> Nova Categoria
        </button>
      </div>
    </div>

    <br />

    <hr />

    <div class="row">
      <div class="col-md-4">
        <text-input
          :alias="'Pesquisar'"
          v-model="searchForm.description"
        ></text-input>
      </div>
      <div class="col-md-4 d-flex align-items-end">
        <div class="form-group">
          <button
            type="button"
            class="btn btn-sm btn-primary"
            @click="select()"
          >
            <i class="fas fa-search" /> Pesquisar
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <b-form-checkbox
          switch
          inline
          @change="select($event)"
          :value="1"
          :unchecked-value="0"
          v-model="searchForm.status"
        >
          <small>Listar Somente Ativos</small>
        </b-form-checkbox>
      </div>
    </div>
    <br />

    <div class="row">
      <div class="col-md-12">
        <table-paginator :data="categories" @pagechange="select($event)">
          <div class="row grid-table-heading"></div>
          <hr />
          <div
            class="row grid-table-row d-flex align-items-center pl-3"
            v-for="(row, index) in categories.data"
            :key="index"
            @click="openCategoryForm(row.id)"
          >
            <avatar
              inline
              color="#fff"
              :size="30"
              :username="row.description"
              :initials="getInitial(row.description)"
            ></avatar>
            <div class="col-md-6">{{ row.description }}</div>
          </div>
        </table-paginator>
      </div>
      <category-form ref="categoryForm" @stored="select" />
    </div>
  </div>
</template>

<script>
  import TablePaginator from "./../../components/sections/TablePaginator";
  import CategoryForm from "../../components/category/forms/CategoryForm";
  import Avatar from "vue-avatar";

  export default {
    components: {
      TablePaginator,
      CategoryForm,
      Avatar
    },

    data: function() {
      return {
        searchForm: {
          description: null,
          status: 1,
          page: null
        }
      };
    },
    computed: {
      categories() {
        return this.$store.state.category.categories;
      }
    },

    created() {
      this.select();
    },

    methods: {
      openCategoryForm(id = null) {
        this.$refs.categoryForm.open(id);
      },

      select(page = 1) {
        this.searchForm.page = page;
        this.$store
          .dispatch("category/getCategories", this.searchForm)
          .then(response => {
            this.$store.commit("pageHasLoaded");
          })
          .catch(error => {
            this.error = error;
            this.$store.commit("pageHasLoadedWithError", {
              error: error
            });
          });
      },

      getInitial(value) {
        return value.slice(0, 2);
      }
    }
  };
</script>

<style>
</style>
